import { FuelButton, FuelCallout, FuelTypography, FuelRadio } from '@frete.com/fuel-react'
import styled, { css } from 'styled-components'
import { StyledContainerProps } from './types'

export const Container = styled.div<StyledContainerProps>`
  margin-bottom: ${({ theme }) => theme.spacing.km6};

  ${({ $isButtonVisible }) =>
    $isButtonVisible &&
    css`
      margin-bottom: 140px;
    `}
`

export const Title = styled(FuelTypography).attrs({ size: 'heading-sm', color: 'neutral-strong', weight: 'bold' })``

export const Label = styled(FuelTypography).attrs({ size: 'caption', color: 'neutral-strong', weight: 'bold' })`
  margin-bottom: ${({ theme }) => theme.spacing.km3};
`

export const Button = styled(FuelButton)`
  width: 360px;
`

export const Footer = styled.footer`
  box-shadow: 0px 8px 28px -6px rgba(38, 47, 74, 0.12), 0px 18px 88px -4px rgba(38, 47, 74, 0.14);
  padding: ${({ theme }) => theme.spacing.km6};
  display: flex;
  justify-content: center;
  border-width: ${({ theme }) => theme.border.width.thinner};
  border-style: ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.color.border.neutral.default};
  width: 100%;
  position: fixed;
  z-index: 1;
  background: white;
  left: 0;
  bottom: 0;
`

export const Line = styled.div`
  background: ${({ theme }) => theme.color.background.neutral.weak};
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.km6};
  margin-bottom: ${({ theme }) => theme.spacing.km10};
  height: ${({ theme }) => theme.border.width.thick};
`

export const Callout = styled(FuelCallout).attrs({ icon: 'alert', fullWidth: true })`
  margin-bottom: ${({ theme }) => theme.spacing.km10};
`

export const Radio = styled(FuelRadio)`
  margin-top: ${({ theme }) => theme.spacing.km2};
  margin-bottom: ${({ theme }) => theme.spacing.km4};
`
